export default "__VITE_ASSET__5pMsCBaz__"